export const boxShadows = {
  stroke: '0 0 0 2px rgba(51, 51, 51, 1)',
  small: '0 12px 8px 0 rgba(37, 39, 82, 0.02)',
  medium: '0 0 16px rgba(37, 39, 82, 0.1)',
  large: '0 16px 40px rgba(37, 39, 82, 0.14)',
};
